var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XForm } from "@bluelibs/x-ui-admin";
import { Service, Inject } from "@bluelibs/core";
import { SmileOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { CommentsCollection, } from "@bundles/UIAppBundle/collections";
let CommentEditForm = class CommentEditForm extends XForm {
    build() {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "text",
                label: t("management.comments.fields.text"),
                name: ["text"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "visibility",
                label: t("management.comments.fields.visibility"),
                name: ["visibility"],
                required: true,
                initialValue: "PRIVATE",
                render: (props) => (_jsx(Ant.Form.Item, { ...props, children: _jsxs(Ant.Select, { placeholder: t("management.comments.fields.visibility"), children: [_jsx(Ant.Select.Option, { value: "PRIVATE", children: "Private" }, "PRIVATE"), _jsx(Ant.Select.Option, { value: "PUBLIC", children: "Public" }, "PUBLIC"), _jsx(Ant.Select.Option, { value: "AGENCY", children: "Agency" }, "AGENCY")] }) })),
            },
            {
                id: "attachmentsId",
                label: t("management.comments.fields.attachments"),
                name: ["attachmentsId"],
                component: UIComponents.AdminFileGroupUpload,
                componentProps: { field: "_id" },
            },
        ]);
    }
    static getRequestBody() {
        return {
            _id: 1,
            text: 1,
            visibility: 1,
            jobEstimationId: 1,
            attachments: {
                _id: 1,
                name: 1,
                files: {
                    downloadUrl: 1,
                    name: 1,
                },
            },
            attachmentsId: 1,
        };
    }
    onSubmit(_id, values) {
        const { t } = this.i18n;
        return this.collection
            .updateOne(_id, { $set: values })
            .then(({ _id }) => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.comments.edit_confirmation"),
                icon: _jsx(SmileOutlined, {}),
            });
        })
            .catch((err) => {
            Ant.notification.warn({
                message: t("generics.error"),
                description: t("generics.error_message"),
            });
        });
    }
};
__decorate([
    Inject(() => CommentsCollection),
    __metadata("design:type", typeof (_a = typeof CommentsCollection !== "undefined" && CommentsCollection) === "function" ? _a : Object)
], CommentEditForm.prototype, "collection", void 0);
CommentEditForm = __decorate([
    Service({ transient: true })
], CommentEditForm);
export { CommentEditForm };
